// @flow

const getValueOrArrayHead = <T>(value: T[] | T): T => (
  Array.isArray(value) ? value[0] : value
);

export default getValueOrArrayHead;
